import debounce from "lodash/debounce"

class Menu {
  constructor() {
    this.bindEvents()

    window.addEventListener("resize", () => {
      this.resize()
    })

    this.resize()
  }

  bindEvents() {
    const menuItemButtons = document.querySelectorAll(".main-navigation__list button")

    menuItemButtons.forEach(b => {
      b.addEventListener(
        "click",
        debounce(ev => {
          this.handleSubmenuToggle(ev)
        }, 150)
      )
    })
  }

  /** Event handlers */
  handleSubmenuToggle(ev) {
    const button = ev.target
    const submenu = document.getElementById(button.getAttribute("aria-controls"))

    if (submenu) {
      this.closeOpenSubmenus(submenu)
      if (submenu.classList.contains("header-nav__submenu--open")) {
        // Close submenu
        this.closeSubmenu(button, submenu)
      } else {
        // Open submenu
        this.openSubmenu(button, submenu)
      }
    }
  }

  /** Submenu methods */
  openSubmenu(button, submenu) {
    button.setAttribute("aria-expanded", "true")
    button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Open/, "Close"))
    button.parentNode.classList.add("active")

    button.querySelector("i").textContent = "expand_less"

    submenu.classList.add("header-nav__submenu--open")
    submenu.setAttribute("aria-hidden", "false")

    this.addOverlay()
  }

  closeSubmenu(button, submenu) {
    button.setAttribute("aria-expanded", "false")
    button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Close/, "Open"))
    button.parentNode.classList.remove("active")

    button.querySelector("i").textContent = "expand_more"

    submenu.classList.remove("header-nav__submenu--open")
    submenu.setAttribute("aria-hidden", "true")

    this.removeOverlay()
  }

  closeOpenSubmenus(submenu) {
    const openSubmenus = document.querySelectorAll(".header-nav__submenu--open")

    openSubmenus.forEach(o => {
      if (o !== submenu) {
        const btn = o.parentNode.querySelector("button")

        btn.setAttribute("aria-expanded", "false")
        btn.setAttribute("aria-label", btn.getAttribute("aria-label").replace(/^Close/, "Open"))
        btn.parentNode.classList.remove("active")

        btn.querySelector("i").textContent = "expand_more"

        o.classList.remove("header-nav__submenu--open")
        o.setAttribute("aria-hidden", "true")
      }
    })
  }

  resize() {
    const main = document.querySelector("main[role='main']")
    const footer = document.querySelector(".footer")
    const navColumn = document.querySelector(".main-navigation__col-nav")
    const button = document.getElementById("MobileNavToggle")
    const icon = button.querySelector("i")

    if (window.matchMedia("(min-width: 1120px)").matches) {
      if (navColumn.classList.contains("main-navigation__col-nav--open")) {
        navColumn.classList.remove("main-navigation__col-nav--open")

        if (main && footer) {
          if (main.getAttribute("aria-hidden") === "true") {
            main.setAttribute("aria-hidden", "false")
          }

          if (footer.getAttribute("aria-hidden") === "true") {
            footer.setAttribute("aria-hidden", "false")
          }
        }

        if (icon) {
          icon.textContent = "menu"
        }

        button.setAttribute("aria-label", "Open menu")
        button.setAttribute("aria-expanded", "false")
        navColumn.setAttribute("aria-hidden", "false")

        this.removeOverlay()
      } else {
        button.setAttribute("aria-label", "Open menu")
        button.setAttribute("aria-expanded", "false")
        navColumn.setAttribute("aria-hidden", "false")
      }
    } else {
      if (navColumn.classList.contains("main-navigation__col-nav--open")) {
        button.setAttribute("aria-label", "Close menu")
        button.setAttribute("aria-expanded", "true")
        navColumn.setAttribute("aria-hidden", "false")
      } else {
        button.setAttribute("aria-label", "Open menu")
        button.setAttribute("aria-expanded", "false")
        navColumn.setAttribute("aria-hidden", "true")
      }
    }
  }

  handleOverlayToggle() {
    const overlay = document.querySelector(".header-nav__overlay")

    if (!overlay) {
      this.addOverlay()
    } else {
      this.closeOpenSubmenus(null)
      this.removeOverlay()
    }
  }

  addOverlay() {
    if (!document.querySelector(".header-nav__overlay")) {
      const header = document.querySelector(".header")
      const body = document.querySelector("body")
      const overlay = document.createElement("div")

      overlay.classList.add("header-nav__overlay")
      overlay.style.height = `${body.clientHeight - header.clientHeight}px`

      overlay.addEventListener("click", () => {
        this.handleOverlayToggle()
      })

      header.appendChild(overlay)
    }
  }

  removeOverlay() {
    const overlay = document.querySelector(".header-nav__overlay")

    if (overlay) {
      overlay.remove()

      overlay.removeEventListener("click", () => {
        this.handleOverlayToggle()
      })
    }
  }
}

export default function init() {
  new Menu()
}
